import { Partner } from '../../shared/domain/partner.entity';
import { NewPartnerInvite } from '../../shared/domain/partner-invite.entity';
import { DMSConnectState } from '../domain/dms-connect.entity';

const INITIAL_STATE: TraxPartnersState = {
  InvitationsCount: 0,
  PartnersCount: 0,
  SelectedPartner: {
    accountId: null, company: null, address: null, city: null, state: null, zipCode: null, shopId: null, discount: null,
    lastModifiedDate: null, contactFirstName: null, contactLastName: null, marketId: null, lastOrdered: null, isOpsTrax: null
  },
  NewPartnerInvite: {
    isValutraxDealer: null,
    selectedShop: null, message: null, customMessage: null,
    discounts: null, mechDiscounts: null, collisionDiscounts: null,
    contacts: [], wantsCopy: false, emailTemplate: null,
    invitationMessage: null,
    hasNoDiscounts: false,
    encrypted:  true,
    isMechanicalDealer: false,
    isCollisionDealer: false,
    isMechanicalShop: false,
    isCollisionShop: false
  },
  DMSConnect: {
    isCustomerNumberEnabled : false
  }
};


const NAMESPACE = 'TRAXPARTNERS';

export const TraxPartnersActions = {
  INIT: `${NAMESPACE}.INIT`,
  SET_IS_VALUTRAX_DEALER: `${NAMESPACE}.SET_IS_VALUTRAX_DEALER`,
  SET_INVITATIONS_COUNT: `${NAMESPACE}.SET_INVITATIONS_COUNT`,
  SET_PARTNERS_COUNT: `${NAMESPACE}.SET_PARTNERS_COUNT`,
  SELECT_PARTNER: `${NAMESPACE}.SELECT_PARTNER`,

  SELECT_NEW_INVITE: `${NAMESPACE}.SELECT_NEW_INVITE`,
  SET_INVITE_MESSAGES: `${NAMESPACE}.SET_INVITE_MESSAGES`,
  SET_INVITE_VALUTRAX_DISCOUNTS: `${NAMESPACE}.SET_INVITE_VALUTRAX_DISCOUNTS`,
  SET_INVITE_CONTACTS: `${NAMESPACE}.SET_INVITE_CONTACTS`,
  SET_INVITE_ACCOUNT: `${NAMESPACE}.SET_INVITE_ACCOUNT`,
  SET_INVITE_GENERAL: `${NAMESPACE}.SET_INVITE_GENERAL`,

  UPDATE_WIZARD_SESSION: `${NAMESPACE}.UPDATE_WIZARD_SESSION`,
  CLEAN_WIZARD_SESSION: `${NAMESPACE}.CLEAN_WIZARD_SESSION`,
  SET_EMAIL_TEMPLATE: `${NAMESPACE}.SET_EMAIL_TEMPLATE`,
  SET_INVITATION_MESSAGE: `${NAMESPACE}.SET_INVITATION_MESSAGE`,
  SET_HAS_NO_DISCOUNTS: `${NAMESPACE}.SET_HAS_NO_DISCOUNTS`,
  SET_DMS_CONNECT: `${NAMESPACE}.SET_DMS_CONNECT`,
  SET_INVITE_WHOLE_DISCOUNTS: `${NAMESPACE}.SET_INVITE_WHOLE_DISCOUNTS`,
  CLEAR_WHOLE_DISCOUNTS: `${NAMESPACE}.CLEAR_WHOLE_DISCOUNTS`,
};

export function TraxPartnersReducer(state: TraxPartnersState = INITIAL_STATE, action: any) {
  const temp = {...state};
  switch (action.type) {
    case TraxPartnersActions.INIT:
      return {...INITIAL_STATE};
    case TraxPartnersActions.SET_IS_VALUTRAX_DEALER:
      temp.NewPartnerInvite.isValutraxDealer = action.payload;
      return temp;
    case TraxPartnersActions.SET_INVITATIONS_COUNT:
      temp.InvitationsCount = action.payload;
      return temp;
    case TraxPartnersActions.SET_PARTNERS_COUNT:
      temp.PartnersCount = action.payload;
      return temp;
    case TraxPartnersActions.SELECT_PARTNER:
      temp.SelectedPartner = action.payload;
      return temp;
    case TraxPartnersActions.SELECT_NEW_INVITE:
      temp.NewPartnerInvite = action.payload;
      return temp;
    case TraxPartnersActions.SET_INVITE_MESSAGES:
      temp.NewPartnerInvite.message = action.payload[0];
      temp.NewPartnerInvite.customMessage = action.payload[1];
      return temp;
    case TraxPartnersActions.SET_INVITE_VALUTRAX_DISCOUNTS:
      temp.NewPartnerInvite.discounts = action.payload.valutraxDiscounts;
      return temp;
    case TraxPartnersActions.SET_INVITE_CONTACTS:
      temp.NewPartnerInvite.contacts = action.payload;
      return temp;
    case TraxPartnersActions.SET_INVITE_ACCOUNT:
      temp.NewPartnerInvite.selectedShop = {...action.payload};
      temp.NewPartnerInvite.dmsCustomerNumber = action.payload.dmsCustomerNumber;
      return temp;
    case TraxPartnersActions.SET_INVITE_GENERAL:
      temp.NewPartnerInvite.wantsCopy = action.payload;
      return temp;

    case TraxPartnersActions.UPDATE_WIZARD_SESSION:
      // state.WizardSession = action.payload;
      return temp;
    case TraxPartnersActions.CLEAN_WIZARD_SESSION:
      temp.NewPartnerInvite.selectedShop = null;
      temp.NewPartnerInvite.message = null;
      temp.NewPartnerInvite.customMessage = null;
      temp.NewPartnerInvite.discounts = null;
      temp.NewPartnerInvite.contacts = [];
      temp.NewPartnerInvite.wantsCopy = false;
      temp.NewPartnerInvite.emailTemplate = null;
      temp.NewPartnerInvite.invitationMessage = null;
      temp.NewPartnerInvite.mechDiscounts = [];
      temp.NewPartnerInvite.collisionDiscounts = [];
      temp.NewPartnerInvite.isCollisionDealer = false;
      temp.NewPartnerInvite.isMechanicalDealer = false;
      temp.NewPartnerInvite.isCollisionShop = false;
      temp.NewPartnerInvite.isMechanicalShop = false;
      return temp;
    case TraxPartnersActions.SET_EMAIL_TEMPLATE:
      temp.NewPartnerInvite.emailTemplate = action.payload;
      return temp;
    case TraxPartnersActions.SET_INVITATION_MESSAGE:
      temp.NewPartnerInvite.invitationMessage = action.payload;
      return temp;
    case TraxPartnersActions.SET_HAS_NO_DISCOUNTS:
      temp.NewPartnerInvite.hasNoDiscounts = action.payload;
      return temp;
    case TraxPartnersActions.SET_DMS_CONNECT:
      temp.DMSConnect.isCustomerNumberEnabled = action.payload.isCustomerNumberEnabled;
      return temp;
    case TraxPartnersActions.SET_INVITE_WHOLE_DISCOUNTS:
      temp.NewPartnerInvite.mechDiscounts = action.payload.mechanicalDiscounts;
      temp.NewPartnerInvite.collisionDiscounts = action.payload.collisionDiscounts;
      temp.NewPartnerInvite.isMechanicalDealer = action.payload.isMechanicalDealer;
      temp.NewPartnerInvite.isCollisionDealer = action.payload.isCollisionDealer;
      temp.NewPartnerInvite.isMechanicalShop = action.payload.isMechanicalShop;
      temp.NewPartnerInvite.isCollisionShop = action.payload.isCollisionShop;
      return temp;
    case TraxPartnersActions.CLEAR_WHOLE_DISCOUNTS:
      temp.NewPartnerInvite.mechDiscounts = [];
      temp.NewPartnerInvite.collisionDiscounts = [];
      temp.NewPartnerInvite.isMechanicalDealer = false;
      temp.NewPartnerInvite.isCollisionDealer = false;
      temp.NewPartnerInvite.isMechanicalShop = false;
      temp.NewPartnerInvite.isCollisionShop = false;
      return temp;
    default:
      return temp;
  }
}


export interface TraxPartnersState {
  InvitationsCount: number;
  PartnersCount: number;
  SelectedPartner: Partner;
  NewPartnerInvite: NewPartnerInvite;
  DMSConnect: DMSConnectState;
  // WizardSession: WizardSession;
}
export interface WizardSession {
  currentStep: number;
}


